import { render, staticRenderFns } from "./ShipMap_origin.vue?vue&type=template&id=267ab660&scoped=true"
import script from "./ShipMap_origin.vue?vue&type=script&lang=js"
export * from "./ShipMap_origin.vue?vue&type=script&lang=js"
import style0 from "./ShipMap_origin.vue?vue&type=style&index=0&id=267ab660&prod&scoped=true&lang=css"
import style1 from "./ShipMap_origin.vue?vue&type=style&index=1&id=267ab660&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ab660",
  null
  
)

export default component.exports